import { devtools } from "zustand/middleware";
import { create } from "zustand";

/** 
    // Documentation: https://zustand.docs.pmnd.rs/guides/updating-state 
    // Example usage
    export const useUserStore = createStore((set) => ({
        name: "Tomathy",
        setName: (name) => set(() => ({ name }), false, "user/setName"),
    }));

    // Pass the same function to createStore you would normally pass directly to the zustand create function.
    // Within the 'set' function the second param is the 'replace' state flag and the third param is what will show up as the name
    // for the action in the redux tools
*/

export const createStoreWithTools = (fn) => create(devtools(fn));
export const createStore = (fn) => create(fn);
